import { Link } from "react-router-dom";
import { ArrowRight, Calculator, BookOpen, Briefcase, GitCompare, ListChecks, FileText } from "lucide-react";
import { reachGoal } from "@/lib/metrika";

const ITEMS = [
  { to: "/calculator", icon: Calculator, title: "Калькулятор штрафов", desc: "Узнайте свой риск за 30 секунд", goal: "related_calc" },
  { to: "/cases", icon: Briefcase, title: "Кейсы клиентов", desc: "Как блогеры избежали 4,5 млн ₽ штрафа", goal: "related_cases" },
  { to: "/vs", icon: GitCompare, title: "Сравнение с ОРД", desc: "ERIDON vs Яндекс / VK / OZON", goal: "related_vs" },
  { to: "/cheklisty", icon: ListChecks, title: "Чек-листы 2026", desc: "Полный набор для блогера и агентства", goal: "related_checklists" },
  { to: "/articles", icon: BookOpen, title: "База знаний", desc: "ФЗ-347, ФЗ-168, ФЗ-152 простым языком", goal: "related_kb" },
  { to: "/pricing", icon: FileText, title: "Тарифы и цены", desc: "1 ERID бесплатно, далее от 1 425 ₽/мес", goal: "related_pricing" },
];

export function RelatedPagesGrid() {
  return (
    <section
      aria-label="Что почитать дальше"
      className="mx-auto mt-20 w-full max-w-6xl px-4"
    >
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-widest text-primary">
            Не уходите без главного
          </p>
          <h2 className="mt-1 text-2xl font-bold text-foreground sm:text-3xl">
            Что почитать дальше
          </h2>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map(({ to, icon: Icon, title, desc, goal }) => (
          <Link
            key={to}
            to={to}
            onClick={() => reachGoal(goal)}
            className="glass-card group relative flex items-start gap-4 p-5 transition-all hover:-translate-y-0.5 hover:border-primary/40"
          >
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <Icon className="h-5 w-5" />
            </div>
            <div className="flex-1">
              <h3 className="text-base font-semibold text-foreground group-hover:text-primary">
                {title}
              </h3>
              <p className="mt-1 text-sm text-muted-foreground">{desc}</p>
            </div>
            <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-1 group-hover:text-primary" aria-hidden="true" />
          </Link>
        ))}
      </div>
    </section>
  );
}
